import { z } from 'zod';
import { DateSchema } from './base';

export const CellInfoSchema = z
  .object({
    radio: z.enum(['GSM', 'UMTS', 'CDMA', 'LTE', 'NR']),
    mcc: z.number(),
    net: z.number(),
    area: z.number(),
    cell: z.number(),
    unit: z.number().optional(),
    lon: z.number(),
    lat: z.number(),
    cellRange: z.number(),
    samples: z.number(),
    changeable: z.boolean().optional(),
    createdAt: DateSchema.optional(),
    updatedAt: DateSchema.optional(),
    averageSignal: z.number().optional(),
  })
  .transform((data) => ({
    radio: data.radio,
    mcc: data.mcc,
    mnc: data.net, // Rename net to mnc
    lac: data.area, // Rename area to lac
    cellId: data.cell, // Rename cell to cellId
    unit: data.unit,
    lat: data.lat,
    lng: data.lon, // Rename lon to lng
    range: data.cellRange, // Rename cellRange to range
    samples: data.samples,
    changeable: data.changeable,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    averageSignal: data.averageSignal,
  }));

export type CellInfo = z.infer<typeof CellInfoSchema>;

export const MultipleCellInfosSchema = z.object({
  cells: z.array(CellInfoSchema),
  nextCursor: z.string().optional(),
  hasMore: z.boolean(),
});

export type MultipleCellInfos = z.infer<typeof MultipleCellInfosSchema>;
